import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import * as sha256 from 'sha256';

export default class LoginRequest extends GenericRequest {

    email;
    password;
    remember;

    constructor(email, password, remember = false) {
        super(METHOD_POST, ApiEndpoints.LOGIN);

        this.email = email;
        this.password = password;
        this.remember = remember;
    }

    overrideRequest() {
        const request = {};
        if ( this.email ) request.email = this.email;
        if ( this.password ) request.password = sha256(this.password);
        request.remember = this.remember;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/ws/LoginRequest.js